// duplication of calling-remote-app/static/js/calling-remote-dialer/common/context/PhoneNumberContext.tsx
import { createContext, useContext, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const PhoneNumberContext = /*#__PURE__*/createContext({
  rawToNumber: '',
  setRawToNumber: () => void 0,
  formattedToNumber: '',
  setFormattedToNumber: () => void 0,
  selectedCallableObject: null,
  setSelectedCallableObject: () => void 0,
  isValidToNumber: false,
  setIsValidToNumber: () => void 0,
  toNumberPropertyName: '',
  setToNumberPropertyName: () => void 0,
  callerIdData: {},
  setCallerIdData: () => void 0
});
export default function PhoneNumberContextProvider({
  children
}) {
  const [selectedCallableObject, setSelectedCallableObject] = useState(null);
  const [rawToNumber, setRawToNumber] = useState('');
  const [formattedToNumber, setFormattedToNumber] = useState('');
  const [toNumberPropertyName, setToNumberPropertyName] = useState('');
  const [isValidToNumber, setIsValidToNumber] = useState(false);
  const [callerIdData, setCallerIdData] = useState({});
  return /*#__PURE__*/_jsx(PhoneNumberContext.Provider, {
    value: {
      rawToNumber,
      setRawToNumber,
      formattedToNumber,
      setFormattedToNumber,
      selectedCallableObject,
      setSelectedCallableObject,
      isValidToNumber,
      setIsValidToNumber,
      toNumberPropertyName,
      setToNumberPropertyName,
      callerIdData,
      setCallerIdData
    },
    children: children
  });
}
export const usePhoneNumberContext = () => {
  const context = useContext(PhoneNumberContext);
  if (context === undefined) {
    throw new Error('Context must be used within a Provider');
  }
  return context;
};